/**
 * @fileoverview gRPC-Web generated client stub for messages
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v5.27.0
// source: messages.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var google_protobuf_any_pb = require('google-protobuf/google/protobuf/any_pb.js')

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js')
const proto = {};
proto.messages = require('./messages_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.messages.MessagesClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.messages.MessagesPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.messages.MessageRequest,
 *   !proto.messages.MessageResponse>}
 */
const methodDescriptor_Messages_MessageSubscriber = new grpc.web.MethodDescriptor(
  '/messages.Messages/MessageSubscriber',
  grpc.web.MethodType.SERVER_STREAMING,
  proto.messages.MessageRequest,
  proto.messages.MessageResponse,
  /**
   * @param {!proto.messages.MessageRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.messages.MessageResponse.deserializeBinary
);


/**
 * @param {!proto.messages.MessageRequest} request The request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.messages.MessageResponse>}
 *     The XHR Node Readable Stream
 */
proto.messages.MessagesClient.prototype.messageSubscriber =
    function(request, metadata) {
  return this.client_.serverStreaming(this.hostname_ +
      '/messages.Messages/MessageSubscriber',
      request,
      metadata || {},
      methodDescriptor_Messages_MessageSubscriber);
};


/**
 * @param {!proto.messages.MessageRequest} request The request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.messages.MessageResponse>}
 *     The XHR Node Readable Stream
 */
proto.messages.MessagesPromiseClient.prototype.messageSubscriber =
    function(request, metadata) {
  return this.client_.serverStreaming(this.hostname_ +
      '/messages.Messages/MessageSubscriber',
      request,
      metadata || {},
      methodDescriptor_Messages_MessageSubscriber);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.messages.MessageRequest,
 *   !proto.messages.ParticipantResponse>}
 */
const methodDescriptor_Messages_ParticipantSubscriber = new grpc.web.MethodDescriptor(
  '/messages.Messages/ParticipantSubscriber',
  grpc.web.MethodType.SERVER_STREAMING,
  proto.messages.MessageRequest,
  proto.messages.ParticipantResponse,
  /**
   * @param {!proto.messages.MessageRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.messages.ParticipantResponse.deserializeBinary
);


/**
 * @param {!proto.messages.MessageRequest} request The request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.messages.ParticipantResponse>}
 *     The XHR Node Readable Stream
 */
proto.messages.MessagesClient.prototype.participantSubscriber =
    function(request, metadata) {
  return this.client_.serverStreaming(this.hostname_ +
      '/messages.Messages/ParticipantSubscriber',
      request,
      metadata || {},
      methodDescriptor_Messages_ParticipantSubscriber);
};


/**
 * @param {!proto.messages.MessageRequest} request The request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.messages.ParticipantResponse>}
 *     The XHR Node Readable Stream
 */
proto.messages.MessagesPromiseClient.prototype.participantSubscriber =
    function(request, metadata) {
  return this.client_.serverStreaming(this.hostname_ +
      '/messages.Messages/ParticipantSubscriber',
      request,
      metadata || {},
      methodDescriptor_Messages_ParticipantSubscriber);
};


module.exports = proto.messages;

